/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.224.2-v202611051605-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export interface CaptureInputV1 {
    /**
     * The capture's description
     */
    "description"?: string;
    /**
     * The capture's title
     */
    "title": string;
    /**
     * The kind of view the capture was taken from
     */
    "viewType": ViewTypeEnum;
    /**
     * The workbook the capture was taken from
     */
    "workbookId": string;
    /**
     * The worksheet the capture was taken from
     */
    "worksheetId": string;
    /**
     * The workstep the capture was taken from
     */
    "workstepId": string;
}

export const ViewTypeEnum = {
    Trend: 'trend',
    Scatter: 'scatter',
    Table: 'table',
    Treemap: 'treemap'
} as const;

export type ViewTypeEnum = typeof ViewTypeEnum[keyof typeof ViewTypeEnum];
